class PrintSet extends HTMLElement {
  connectedCallback() {
    this.pieces = Array.prototype.slice.call(this.querySelectorAll('[data-piece]'));
    if (!this.pieces.length) return;

    this.countEl = this.querySelector('[data-set-count]');
    this.totalEl = this.querySelector('[data-set-total]');
    this.noteEl = this.querySelector('[data-set-note]');
    this.errorEl = this.querySelector('[data-set-error]');
    this.addButton = this.querySelector('[data-set-add]');

    this.threshold = parseInt(this.dataset.threshold, 10) || 0;
    this.freeLabel = this.dataset.freeLabel || '';

    this.wordOne = this.dataset.wordOne || '';
    this.wordMany = this.dataset.wordMany || '';
    this.addLabel = this.addButton ? this.addButton.textContent.trim() : '';

    this.pieces.forEach((piece) => {
      piece.addEventListener('click', () => this.toggle(piece));
      piece.addEventListener('keydown', (event) => {
        if (event.key === ' ') {
          event.preventDefault();
          piece.click();
        }
      });
    });

    if (this.addButton) {
      this.addButton.addEventListener('click', () => this.add());
    }

    this.render();
  }

  get selected() {
    return this.pieces.filter((piece) => piece.dataset.selected === 'true');
  }

  toggle(piece) {
    if (piece.disabled) return;

    var isOn = piece.dataset.selected === 'true';

    if (isOn && this.selected.length === 1) return;

    piece.dataset.selected = isOn ? 'false' : 'true';
    piece.classList.toggle('is-on', !isOn);
    piece.setAttribute('aria-checked', String(!isOn));
    this.render();
  }

  render() {
    var chosen = this.selected;
    var total = chosen.reduce(function (sum, piece) {
      return sum + (parseInt(piece.dataset.price, 10) || 0);
    }, 0);

    if (this.countEl) {
      var word = chosen.length === 1 ? this.wordOne : this.wordMany;
      this.countEl.textContent = (chosen.length + ' ' + word).trim();
    }

    if (this.totalEl) {
      this.totalEl.textContent = window.RappitUtils.formatMoney(total);
    }

    if (this.noteEl) {
      var shipsFree = this.threshold > 0 && total >= this.threshold;
      this.noteEl.textContent = shipsFree ? this.freeLabel : '';
      this.noteEl.hidden = !shipsFree;
    }

    if (this.addButton) {
      this.addButton.textContent = this.addLabel;
      this.addButton.disabled = chosen.length === 0;
    }
  }

  add() {
    var items = this.selected
      .filter(function (piece) {
        return piece.dataset.variant && piece.dataset.available === 'true';
      })
      .map(function (piece) {
        return { id: piece.dataset.variant, quantity: 1 };
      });

    if (!items.length) return;

    this.addButton.setAttribute('aria-busy', 'true');
    this.hideError();

    window.RappitCart.add(items)
      .then(() => {
        if (window.Rappit.cartType === 'drawer') {
          window.RappitDrawers.open('CartDrawer', this.addButton);
        } else {
          window.location.href = window.Rappit.routes.cart;
        }
      })
      .catch((error) => this.showError(error.message))
      .finally(() => this.addButton.setAttribute('aria-busy', 'false'));
  }

  hideError() {
    if (!this.errorEl) return;
    this.errorEl.hidden = true;
    this.errorEl.textContent = '';
  }

  showError(message) {
    if (!this.errorEl) {
      window.RappitUtils.toast(message, 'error');
      return;
    }
    this.errorEl.textContent = message;
    this.errorEl.hidden = false;
  }
}

if (!customElements.get('print-set')) {
  customElements.define('print-set', PrintSet);
}
